import React, { useEffect, useState } from 'react'
import Select from "react-select";

import Breadcrumb from '../Breadcrumb/Breadcrumb';
import { downloadExcel1, getPermissionDetails, stringLimit } from '../../util/fn';
import useRequest from '../../hooks/useRequest';
import axios from 'axios';
import { BASEURL } from '../../constant/api';
import { toast } from 'react-toastify';
import LineGraph from './LineGraph';
import BarChart from './BarChart';

function VendorGrowth() {
  const { request: requestCities, response: responseCities } = useRequest();
  const [cities, setCities] = useState([]);
  const [city, setCity] = useState('');
  const [Dates, setDates] = useState([]);
  const [area, setArea] = useState('');
  const [seriesData, setSeriesData] = useState([{ name: "Vendor", data: [''] }]);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const { request: request, response: response } = useRequest();
  const [permissions, setPermissions] = useState([])
  const [data, setData] = useState('')
  const perPage = 10;
  const [totalDocuments, setTotalDocuments] = useState(10);
  const [page, setPage] = useState(1);

  const [startIndex, setStartIndex] = useState(1);

  useEffect(() => {
    requestCities("GET", "admin/vendor/getCity");
  }, []);

  useEffect(() => {
    const todayDate = new Date();
    todayDate.setDate(todayDate.getDate() - 15);
    setStartDate(todayDate.toISOString().split('T')[0]);

    todayDate.setDate(todayDate.getDate() + 15);
    setEndDate(todayDate.toISOString().split('T')[0]);
  }, [])
  useEffect(() => {

    GetData()
  }, [startDate, endDate]);
  useEffect(() => {
    if (responseCities) {
      if (responseCities.status && responseCities.data) {
        setCities(responseCities.data);

      }
    }
  }, [responseCities]);

  const DownloadExcel = async () => {
    let Ranking = data?.registrationGrowth?.map((obj, index) => ({
      'Sr.': index + 1,
      'Date': obj?.date,
      'Registration': obj?.registration,

    }));
   


    const dataArray = [Ranking];
    const namesArray = ["Vendor Report",];
    const headingsArray = [null, null]; // Assuming no headers for the data

    downloadExcel1(dataArray, namesArray, headingsArray);
  }

  const GetData = async () => {
    const data = {
      city: city,
      area: area,
      startDate: startDate,
      endDate: endDate
    }
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': "Bearer " + localStorage.getItem("token")
      }
    };

    try {
      const response = await axios.post(`${BASEURL.PORT}/admin/report/growthReport`, data, config);
      if (response?.data?.status == true) {
        setData(response?.data?.data)
        setDates(response?.data?.data?.vendorGrowth?.map((val) => (
          val.date
        )))

        const dataa = response?.data?.data?.vendorGrowth?.map((val) => (
          parseInt(val.registration)
        ))
        setSeriesData(
          { name: "Growth", data: [...dataa] }
        );
      }

    } catch (error) {
      toast.error(error.message)
    }
  }



  return (
    <div>

      <div className="ms-content-wrapper">
        <div className="row">
          <div className="col-md-12">
            <Breadcrumb
              title={"vendor Growth Report"}
              links={[{ to: "/", name: "Home" }]}
            />
            <div className="ms-panel">
              <div className="ms-panel-header">
                <div className="row">
                  <div className="col-md-3">
                    <h6>{"Growth Report"}</h6>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-3">
                    <div className="form-group">
                      <label htmlFor="cities">From Date:</label>
                      <input type='date'
                        value={startDate}
                        className='form-control'

                        onChange={(e) => {
                          // Calculate end date as 15 days from the start date
                          const endDate = new Date(e.target.value);
                          endDate.setDate(endDate.getDate() + 15);
                          setEndDate(endDate.toISOString().split('T')[0]);
                          setStartDate(e.target.value)
                        }
                        }
                      />
                    </div>
                  </div>
                  <div className="col-md-3">

                    <div className="form-group">
                      <label htmlFor="cities">To Date:</label>
                      <input type='date'
                        className='form-control'
                        value={endDate}
                        disabled
                        onChange={(e) => setEndDate(e.target.value)} />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label htmlFor="cities">Area:</label>
                      <input type='text'
                        className='form-control'
                        value={area}

                        onChange={(e) => setArea(e.target.value)} />
                    </div>
                  </div>

                  <div className="col-md-3">

                    <div className="form-group">
                      <label htmlFor="cities">City:</label>
                      <Select
                        options={
                          cities &&
                          cities.length > 0 &&
                          cities.map((obj) => ({
                            label: obj.name,
                            value: obj._id,
                          }))
                        }
                        name="cities"
                        onChange={(value) => {
                          setCity(value.value)
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="row">

                  <div className='col-md-6'></div>
                  <div className='col-md-6'>
                    <div className='d-flex justify-content-end'>
                      <button className="mx-3 btn btn-primary" onClick={DownloadExcel}>Download Excel</button>
                      <button className="mx-3 btn btn-primary" onClick={GetData}>Filter</button>
                    </div>
                  </div>

                </div>
              </div>


              <div className='row'>
                <div className='col-md-4'></div>
                <div className='col-md-6'>
                  <div><h5>Vendor  Growth</h5></div>
                </div>
              </div>


              <div className="row">
                <div className='col-md-6'>
                  <div className="ms-panel-body">
                    <div className="table-responsive">
                      <table className="table table-hover thead-primary">
                        <thead>
                          <tr>
                            <th scope="col">Date</th>
                            <th scope="col">Revenue</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            data?.vendorGrowth?.length > 0 &&
                            data?.vendorGrowth?.map((item, i) => (
                              <tr key={item._id}>

                                <td>{item.date}</td>
                                <td>{item.registration
                                }</td>

                              </tr>
                            ))}
                          {data?.vendorGrowth?.length == 0 && (
                            <tr>
                              <td colspan="10" style={{ textAlign: "center" }}>
                                {" "}
                                No Data Found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className='col-md-6'>
                  <BarChart title='Vendor' series={seriesData} categories={Dates} />
                </div>
              </div>



            </div>

          </div>
          {/* <div className="col-md-12">
            {perPage !== 0 &&
              data.length != totalDocuments &&
              data.length != 0 && (
                <Pagination
                  page={page}
                  totalDocuments={totalDocuments}
                  getNewData={fetchMoreData}
                  perPage={perPage}
                  currentDocLength={data.length}
                />
              )}
          </div> */}
        </div>
      </div>
    </div>
  )
}

export default VendorGrowth